export default "__VITE_ASSET__18152e90__"